// extracted by mini-css-extract-plugin
export default {"menuBlock":"XD-z","title":"YD-z","nav":"ZD-z","flexCell":"_D-z","facetLink":"aE-z"};